export default __webpack_public_path__ + "static/media/arrow-dropdown-white.6543ecad.svg";